export const translations = {
  es: {
    // Header
    nav: {
      services: 'Soluciones',
      howWeWork: 'Cómo Trabajamos',
      cases: 'Proyectos',
      contact: 'Contacto',
      whatsapp: 'WhatsApp'
    },
    
    // Hero
    hero: {
      headline: 'Soluciones digitales que conectan y mejoran tu negocio',
      mainText: 'Diseñamos sitios web, conectamos herramientas y automatizamos procesos para que tu empresa trabaje de forma más organizada y eficiente.',
      ctaPrimary: 'Conversemos sobre tu negocio',
      ctaSecondary: 'Conoce nuestras soluciones',
      ctaCalendly: 'Agendar reunión',
      ctaProposal: 'Solicitar propuesta',
      location: 'San Miguel, Chile'
    },
    
    // What RC7 Does
    whatWeDo: {
      title: 'Qué Hace RC7 Innovation',
      description: 'No entregamos herramientas digitales aisladas. Las conectamos en sistemas integrados que funcionan juntos para atraer personas, ordenar información y automatizar tareas repetitivas.'
    },
    
    // Two Systems  
    systems: {
      title: 'Nuestras Soluciones',
      presenceTitle: 'Sistema de Presencia Digital',
      presenceDesc: 'Construimos y mantenemos los canales digitales de tu empresa para que las personas puedan encontrarte, conocer tus servicios y contactarte fácilmente.',
      presenceFeatures: [
        'Sitios web',
        'Instagram y Facebook',
        'Google Business Profile',
        'Meta Business Suite',
        'Conexión con WhatsApp',
        'Contenido digital',
        'Mantenimiento y actualización de sitios web'
      ],
      managementTitle: 'Sistema de Gestión Digital',
      managementDesc: 'Organizamos información, conectamos herramientas y automatizamos tareas para reducir trabajo manual y mejorar el control de tu operación.',
      managementFeatures: [
        'Formularios y registros digitales',
        'Automatización de procesos',
        'Gestión documental',
        'Seguimiento de solicitudes',
        'Microsoft Lists y Power Automate',
        'Integración entre herramientas',
        'Paneles de seguimiento',
        'Sistemas operativos personalizados'
      ],
      customTitle: 'Desarrollo de Soluciones a Medida',
      customDesc: 'Estudiamos cómo funciona tu negocio y evaluamos soluciones digitales para problemas que no se resuelven con herramientas aisladas.',
      customFeatures: [
        'Control de uso de recursos compartidos',
        'Registro y seguimiento de operaciones',
        'Sistemas para pequeños comercios',
        'Gestión de solicitudes',
        'Herramientas internas personalizadas'
      ]
    },
    
    // How We Work
    howWeWork: {
      title: 'Cómo Trabajamos',
      subtitle: 'Un proceso práctico y ordenado',
      step1Title: 'ENTENDEMOS',
      step1Desc: 'Conocemos tu negocio, identificamos los problemas y definimos qué necesitas mejorar.',
      step2Title: 'DISEÑAMOS',
      step2Desc: 'Proponemos una solución digital adaptada a tus procesos y objetivos.',
      step3Title: 'CONECTAMOS',
      step3Desc: 'Integramos las herramientas y la información necesarias para que trabajen juntas.',
      step4Title: 'AUTOMATIZAMOS',
      step4Desc: 'Reducimos tareas repetitivas y facilitamos el trabajo diario.',
      step5Title: 'MEDIMOS',
      step5Desc: 'Revisamos los resultados y detectamos oportunidades de mejora.'
    },
    
    // Projects Section
    projects: {
      title: 'Proyectos y soluciones desarrolladas',
      subtitle: 'Conoce cómo transformamos necesidades reales en herramientas digitales.',
      flujoTitle: 'Flujo SpA',
      flujoCategory: 'Presencia digital y gestión operativa',
      flujoDesc: 'Sistema integrado de presencia digital y gestión operativa',
      laundryTitle: 'Sistema de Gestión de Lavandería',
      laundryCategory: 'Solución de gestión operativa',
      laundryDesc: 'Una herramienta digital desarrollada para facilitar el registro, control y seguimiento del uso de una lavandería.',
      laundryStatus: 'Demostración funcional',
      laundryVideoLabel: 'Demostración del sistema',
      laundryExplanation: 'Digitalizamos el registro y seguimiento de operaciones para facilitar la organización y consulta de información.',
      laundrySolutions: [
        'Registro digital',
        'Consulta de información',
        'Seguimiento de operaciones',
        'Apoyo a la administración'
      ],
      evidenceTitle: 'Así funciona por dentro'
    },
    
    // About
    about: {
      title: 'Sobre RC7 Innovation',
      text1: 'Somos una empresa de soluciones digitales enfocada en resolver problemas operativos y digitales reales.',
      text2: 'Trabajamos de forma práctica y directa, diseñando sistemas que se adaptan a cómo funciona cada negocio.',
      text3: 'No hacemos promesas exageradas. Implementamos soluciones que realmente funcionan.'
    },
    
    // Custom Solutions
    customSolutions: {
      title: '¿Tu negocio tiene un problema que todavía resuelves manualmente?',
      description: 'No todas las empresas necesitan el mismo sistema. En RC7 Innovation analizamos procesos, identificamos oportunidades de mejora y evaluamos soluciones digitales adaptadas a cada operación.',
      examples: [
        {
          title: 'Información dispersa',
          description: 'Conectamos registros y herramientas para facilitar su consulta.'
        },
        {
          title: 'Tareas repetitivas',
          description: 'Evaluamos qué actividades pueden automatizarse.'
        },
        {
          title: 'Falta de seguimiento',
          description: 'Diseñamos formas de registrar y consultar el estado de las operaciones.'
        }
      ],
      cta: 'Cuéntanos qué necesitas resolver'
    },
    
    // Final CTA
    finalCta: {
      headline: 'Conversemos sobre lo que tu negocio necesita',
      text1: 'Cuéntanos cómo trabajas, qué te gustaría mejorar o qué proceso necesitas organizar.',
      text2: 'Evaluaremos contigo una solución adecuada.',
      button: 'Hablar por WhatsApp',
      buttonSecondary: 'Solicitar una propuesta',
      note: 'Sin compromisos. Solo una conversación directa.'
    },
    
    // Footer
    footer: {
      tagline: 'Soluciones digitales integradas',
      contactTitle: 'Contacto',
      location: 'San Miguel, Chile',
      copyright: 'RC7 Innovation. Todos los derechos reservados.'
    },
    
    // Proposal CTA
    proposalCta: {
      headline: 'Solicita una Propuesta',
      subtext: 'Te ayudamos a definir la mejor solución para tu negocio.',
      button: 'Solicitar Propuesta',
      microcopy: 'Propuesta gratuita y sin compromiso.'
    },
    
    // Language Modal
    languageModal: {
      title: 'Selecciona tu idioma',
      subtitle: 'Choose your language'
    }
  },
  
  en: {
    // Keep English for system purposes but site remains Spanish
    nav: {
      services: 'Solutions',
      howWeWork: 'How We Work',
      cases: 'Projects',
      contact: 'Contact',
      whatsapp: 'WhatsApp'
    },
    hero: {
      headline: 'Digital solutions that connect and improve your business',
      mainText: 'We design websites, connect tools and automate processes so your company works in a more organized and efficient way.',
      ctaPrimary: 'Let\'s talk about your business',
      ctaSecondary: 'Discover our solutions',
      ctaCalendly: 'Schedule meeting',
      ctaProposal: 'Request proposal',
      location: 'San Miguel, Chile'
    },
    whatWeDo: {
      title: 'What RC7 Innovation Does',
      description: 'We don\'t deliver isolated digital tools. We connect them into integrated systems that work together to attract people, organize information and automate repetitive tasks.'
    },
    systems: {
      title: 'Our Solutions',
      presenceTitle: 'Digital Presence System',
      presenceDesc: 'We build and maintain your company\'s digital channels so people can find you, learn about your services and contact you easily.',
      presenceFeatures: [
        'Websites',
        'Instagram and Facebook',
        'Google Business Profile',
        'Meta Business Suite',
        'WhatsApp Connection',
        'Digital content',
        'Website maintenance and updates'
      ],
      managementTitle: 'Digital Management System',
      managementDesc: 'We organize information, connect tools and automate tasks to reduce manual work and improve operational control.',
      managementFeatures: [
        'Digital forms and records',
        'Process automation',
        'Document management',
        'Request tracking',
        'Microsoft Lists and Power Automate',
        'Tool integration',
        'Tracking dashboards',
        'Custom operational systems'
      ],
      customTitle: 'Custom Solution Development',
      customDesc: 'We study how your business works and evaluate digital solutions for problems that cannot be solved with isolated tools.',
      customFeatures: [
        'Shared resource usage control',
        'Operations recording and tracking',
        'Systems for small businesses',
        'Request management',
        'Custom internal tools'
      ]
    },
    howWeWork: {
      title: 'How We Work',
      subtitle: 'A practical and organized process',
      step1Title: 'WE UNDERSTAND',
      step1Desc: 'We learn about your business, identify problems and define what needs to be improved.',
      step2Title: 'WE DESIGN',
      step2Desc: 'We propose a digital solution adapted to your processes and objectives.',
      step3Title: 'WE CONNECT',
      step3Desc: 'We integrate the necessary tools and information so they work together.',
      step4Title: 'WE AUTOMATE',
      step4Desc: 'We reduce repetitive tasks and facilitate daily work.',
      step5Title: 'WE MEASURE',
      step5Desc: 'We review results and detect opportunities for improvement.'
    },
    projects: {
      title: 'Projects and developed solutions',
      subtitle: 'Discover how we transform real needs into digital tools.',
      flujoTitle: 'Flujo SpA',
      flujoCategory: 'Digital presence and operational management',
      flujoDesc: 'Integrated digital presence and operational management system',
      laundryTitle: 'Laundry Management System',
      laundryCategory: 'Operational management solution',
      laundryDesc: 'A digital tool developed to facilitate the recording, control and tracking of laundry usage.',
      laundryStatus: 'Functional demonstration',
      laundryVideoLabel: 'System demonstration',
      laundryExplanation: 'We digitized the recording and tracking of operations to facilitate the organization and consultation of information.',
      laundrySolutions: [
        'Digital recording',
        'Information consultation',
        'Operations tracking',
        'Administration support'
      ],
      evidenceTitle: 'How it works inside'
    },
    
    customSolutions: {
      title: 'Does your business have a problem you still solve manually?',
      description: 'Not all companies need the same system. At RC7 Innovation we analyze processes, identify improvement opportunities and evaluate digital solutions adapted to each operation.',
      examples: [
        {
          title: 'Scattered information',
          description: 'We connect records and tools to facilitate their consultation.'
        },
        {
          title: 'Repetitive tasks',
          description: 'We evaluate which activities can be automated.'
        },
        {
          title: 'Lack of tracking',
          description: 'We design ways to record and check the status of operations.'
        }
      ],
      cta: 'Tell us what you need to solve'
    },
    about: {
      title: 'About RC7 Innovation',
      text1: 'We are a digital solutions company focused on solving real operational and digital problems.',
      text2: 'We work in a practical and direct way, designing systems that adapt to how each business works.',
      text3: 'We don\'t make exaggerated promises. We implement solutions that really work.'
    },
    finalCta: {
      headline: 'Let\'s talk about your business',
      text1: 'Do you have an operational or digital problem that needs to be organized or automated?',
      text2: 'Let\'s talk on WhatsApp or schedule a meeting.',
      button: 'Let\'s talk on WhatsApp',
      buttonSecondary: 'Request a proposal',
      note: 'No commitments. Just a direct conversation.'
    },
    footer: {
      tagline: 'Integrated digital solutions',
      contactTitle: 'Contact',
      location: 'San Miguel, Chile',
      copyright: 'RC7 Innovation. All rights reserved.'
    },
    proposalCta: {
      headline: 'Request a Proposal',
      subtext: 'We help you define the best solution for your business.',
      button: 'Request Proposal',
      microcopy: 'Free proposal with no commitment.'
    },
    languageModal: {
      title: 'Select your language',
      subtitle: 'Selecciona tu idioma'
    }
  }
};

export const getTranslation = (lang, key) => {
  const keys = key.split('.');
  let value = translations[lang];
  
  for (const k of keys) {
    if (value && typeof value === 'object') {
      value = value[k];
    } else {
      return key;
    }
  }
  
  return value || key;
};
